// LAS PUERTAS DEL CLIENTE: quien no tiene acceso, que puede abrir y a donde se le lleva.
//
// La decision vivia repartida en el layout del cliente (pages/ClientDashboard.jsx) y fallaba
// en dos sitios (12-10):
//
//   1. El layout mandaba al cuestionario del alta a todo perfil "activo" que no lo tuviera
//      hecho, SIN mirar si tenia acceso. A quien nace con el acceso vencido (un alta con la
//      fecha pasada) el cuestionario le contestaba 402, el 402 lo devolvia a /dashboard y el
//      layout lo volvia a mandar al cuestionario: pantalla en blanco, sin llegar a "Tu
//      suscripcion ha terminado" y sin poder cerrar sesion.
//   2. El menu del que no tiene acceso enseña "Mi perfil" (ahi estan sus datos, su
//      contraseña y el cierre de sesion), pero la guarda solo dejaba abrir el Inicio, asi
//      que al pulsarlo volvia al Inicio.
//
// Aqui queda una sola regla, pura, que usan el menu, la guarda y el efecto del cuestionario.
// El servidor cierra por su lado con el 402 de `backend/core/candado_de_plan.py`, que deja
// abiertas justo las rutas que estas dos pantallas necesitan (perfil, cuenta, avisos, pago).

import { cierreDelAltaPendiente } from './cierreDelAlta';

/** Las pantallas del panel del cliente que se abren sin acceso: el Inicio, que es donde
 *  esta la salida (elegir plan, renovar, que le escriban), y su perfil. */
export const ABIERTO_SIN_ACCESO = ['/dashboard', '/dashboard/profile'];

/** ¿Este cliente esta sin acceso a la app? Sin ficha tambien es sin acceso (el recien
 *  registrado). Mientras se carga, o si el perfil no se pudo leer, NO: seria echar del
 *  sitio a quien si tiene plan. Al equipo no se le aplica: no compra planes. */
export function sinAccesoALaApp({ loading, esDelEquipo, perfilNoCargado, profile } = {}) {
    if (loading || esDelEquipo || perfilNoCargado) return false;
    return !profile || profile?.acceso?.activo === false;
}

const sinBarraFinal = (ruta) => String(ruta || '').replace(/\/+$/, '') || '/';

/** ¿Puede abrir esta direccion del panel? Con acceso, todas (lo demas lo deciden las
 *  capacidades del plan); sin acceso, solo las de `ABIERTO_SIN_ACCESO`. */
export function puedeAbrir(pathname, sinAcceso) {
    if (!sinAcceso) return true;
    return ABIERTO_SIN_ACCESO.includes(sinBarraFinal(pathname));
}

/** Lo que se abre CON PLAN ACTIVO Y SIN EL CUESTIONARIO HECHO (12-10, decision de Francisco):
 *  Mensajes, para que quien ya pago pueda escribir al equipo (por ejemplo, para arrepentirse)
 *  sin tener que rellenarlo antes, y su perfil. El resto del panel le sigue llevando al
 *  cuestionario. El servidor no cierra el chat por el cuestionario (`/api/messages` va
 *  abierto en `core/candado_de_plan.py`). */
export const ABIERTO_SIN_CUESTIONARIO = ['/dashboard/messages', '/dashboard/profile'];

/** ¿Hay que llevarle al cuestionario del alta? Solo a quien tiene plan en marcha, no lo ha
 *  rellenado (o lo envió y dejó a medias lo de después de los macros: ALT-06, ver
 *  `lib/cierreDelAlta`) Y TIENE ACCESO: quien no lo tiene se queda en el Inicio, que le dice que su
 *  suscripcion ha terminado, tenga o no el cuestionario hecho.
 *  Con `pathname` (la pantalla del panel en la que esta) se respeta `ABIERTO_SIN_CUESTIONARIO`:
 *  desde ahi no se le lleva. Sin `pathname` contesta si lo tiene pendiente. */
export function leTocaElCuestionario(profile, sinAcceso, pathname) {
    if (!profile || sinAcceso) return false;
    if (profile.acceso?.activo === false) return false;
    if (pathname && ABIERTO_SIN_CUESTIONARIO.includes(sinBarraFinal(pathname))) return false;
    return profile.status === 'activo'
        && (!profile.questionnaire_completed || !!cierreDelAltaPendiente(profile));
}
